import { GET_FACILITIES, GET_FACILITY, GET_PLANS } from "../constants/type";
import Api from "../utils/api";
import { EndPoints } from "../constants/endpoints";
import moment from "moment";
import { settings } from "../assets/settings";

export const getFacilities = (data={}) => {
    return (dispatch) => {
        if( settings.zone_id != null ){
            data.zone_id = settings.zone_id;
        }
        return {
            type: GET_FACILITIES,
            payload: () => {
                return Api.get( EndPoints.facilities(), data );
            }
        };
    };
}

export const getFacility = (facilityId) => {
    return (dispatch) => {
        return {
            type: GET_FACILITY,
            payload: () => {
                return Api.get( EndPoints.facilities(facilityId));
            }
        };
    };
}

export const getPlans = (code, param={}) => {

    return (dispatch) => {
        param = Object.assign({}, settings.search_default(), param);
        var data = {
            Language:"ja-JP",
            ManagerID: process.env.REACT_APP_API_MEMBER_ID,
            MemberID: code
        };
        if( param.checkin_at && param.checkin_at.year && param.checkin_at.month && param.checkin_at.date ){
            var dateStr = param.checkin_at.year + ("00" + param.checkin_at.month).slice(-2) + ("00" + param.checkin_at.date).slice(-2);
            data["Date"] = dateStr;
        }
        if( param.adult_num ){
            data["Adult"] = param.adult_num;
        }
        if( param.stay_date ){
            data["Night"] = param.stay_date;
        }
        return {
            type: GET_PLANS,
            payload: () => {
                return Api.pureGet( EndPoints.plans(code), data);
            }
        };
    };
}